<template>
  <div>
    <van-cell 
    v-for="item of location"
    :key="item.shop_id"
    class="location-item"
    >
  <!-- 使用 title 插槽来自定义标题 -->
  <template #title>
    <div class="custom-title">{{item.shop_name}}</div>
    <div class="custom-address"><van-icon name="location-o" />{{item.address}}</div>
  </template>
  <template #extra>
    <div class="right">
      <div>去下单</div>
      <div>{{item.shop_distance}}</div>
    </div>
  </template>
</van-cell>
  </div>
</template>
<script>
export default {
  props: {
    location: {
      type: Array,
    }
  }
}
</script>
<style lang="scss" scoped>
  .location-item{
    width: 7.02rem;
    margin: 10px auto;
    font-family: PingFang SC;
  }
  .custom-title {
    font-size:0.28rem;
    margin-bottom: 5px;
  }

  .custom-address {
    font-size:0.24rem;
    color: $cake-text-grey;
  }
  .right{
    text-align: center;
    :nth-child(1) {
      font-size:0.28rem;
    }
    :nth-child(2) {
      font-size:0.24rem;
    color: $cake-text-grey;
    }
  }
</style>